<div class="auth-title-text">
  {{ 'Verification is needed to complete your log in' }}
</div>

<div class="auth-flow-subtext">
  <div class="subtext">
    {{ viewModel.subText$ | async }}
  </div>
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="timeBasedOneTimePassword" class="form-input-label" i18n>Verification Code</label>
    <app-masked-text-input
      formControlName="code"
      controlId="timeBasedOneTimePassword"
      [maskOptions]="codeMaskOptions"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.code.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.code.invalid"
      [customErrorMessages]="customErrorMessages.code"
      [errors]="formGroup.controls.code.errors" />
  </div>
</form>

<app-primary-button class="w-100" [width]="'100%'" (buttonClicked)="submit()">
  <ng-container i18n>Verify Account</ng-container>
</app-primary-button>
